import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import {ReactComponent as LogoutIcon} from '@fo/shared-images/icons/logout.svg';
import {useIdentityContext} from '@fo/shared-providers/IdentityContext';
import {getPageRoute} from '@fo/utils/routes/getPageRoute';
import {isBrowser} from '@fo/shared/utils/browserSupport';
import {segmentEvents, track} from '@fo/shared-analytics/tracking/segment';

import Button, {ButtonVariant} from '../Button/Button';

interface Props {
  buttonVariant?: ButtonVariant;
  showIcon?: boolean;
  className?: string;
  iconClassName?: string;
  isAuthenticatedPage?: boolean;
}

function LogoutButton({
  buttonVariant = ButtonVariant.PRIMARY_OUTLINE,
  showIcon,
  className = '',
  iconClassName = '',
  isAuthenticatedPage,
}: Props): ReactElement {
  const {logout} = useIdentityContext();
  const {formatMessage} = useIntl();

  return (
    <Button
      ariaLabel={formatMessage({id: 'phoenix.logout.button.text'})}
      id="logout"
      type="button"
      onClick={async () => {
        track(segmentEvents.navigation.logoutButton);

        await logout();

        if (isBrowser) {
          if (isAuthenticatedPage) {
            // Navigates to the home page while refreshing the page to clear identity cache
            window.open(getPageRoute('home'));
          } else {
            // reloads the page clearing identity cache
            window.location.reload();
          }
        }
      }}
      variant={buttonVariant}
      className={className}
    >
      {showIcon && <LogoutIcon className={iconClassName} />}
      <FormattedMessage id="phoenix.logout.button.text" />
    </Button>
  );
}

export default LogoutButton;
